import InputAdornment from '@mui/material/InputAdornment';

export const CustomInputAdornment = InputAdornment;

export default CustomInputAdornment;
